<template>
    <div class="pb-5">
        <v-row>
            <v-col cols="12" md="7">
                <v-card flat class="fullheight">
                    <v-card-text class="fullheight px-0">
                        <div
                            class="d-flex justify-space-between align-center px-5"
                        >
                            <div class="font-weight-600">
                                Konsultasi per Mapel
                            </div>

                            <!-- <div style="max-width: 200px">
                                <v-select
                                    :items="['November 2023', 'November 2024']"
                                    placeholder="Pilih Bulan"
                                    width="200"
                                    dense
                                    outlined
                                    hide-details
                                />
                            </div> -->
                        </div>

                        <div class="pt-10">
                            <v-row>
                                <v-col cols="6">
                                    <div class="donut-container">
                                        <apexcharts
                                            v-if="show"
                                            type="donut"
                                            :options="donutChartOptions"
                                            :series="donutChartData"
                                        ></apexcharts>

                                        <div v-if="show" class="custom-label">
                                            <div
                                                class="font-weight-600 font-size-12 lightgreynew--text"
                                            >
                                                Total
                                            </div>
                                            <div
                                                class="font-weight-700 font-size-20 black--text"
                                            >
                                                {{ formatNumber(totalConsultants) }}
                                            </div>
                                            <div
                                                class="font-weight-bold font-size-12 black--text"
                                            >
                                                Konsultasi
                                            </div>
                                        </div>
                                    </div>
                                </v-col>

                                <v-col>
                                    <div
                                        style="
                                            max-height: 300px;
                                            overflow-y: scroll;
                                            margin-left: 3px;
                                        "
                                    >
                                        <table width="90%">
                                            <tr
                                                v-for="(data, i) in chartMapel"
                                                :key="i"
                                            >
                                                <td
                                                    class="d-flex align-center gap-10 pb-2 pr-3"
                                                >
                                                    <v-icon
                                                        :color="colorPie[i]"
                                                        small
                                                    >
                                                        mdi-circle
                                                    </v-icon>

                                                    {{ data.mapel_name }}
                                                </td>
                                                <td
                                                    class="font-weight-bold black--text pb-2 text-right"
                                                >
                                                    {{
                                                        formatNumber(data.total)
                                                    }}
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="5">
                <v-card flat class="fullheight">
                    <v-card-text class="fullheight px-0">
                        <div
                            class="d-flex justify-space-between align-center px-5"
                        >
                            <div class="font-weight-600">
                                Konsultasi per Status
                            </div>

                            <!-- <div style="max-width: 200px">
                                <v-select
                                    :items="['November 2023', 'November 2024']"
                                    placeholder="Pilih Bulan"
                                    max-width="100"
                                    dense
                                    outlined
                                    hide-details
                                />
                            </div> -->
                        </div>

                        <div class="pt-8">
                            <apexcharts
                                v-if="show"
                                type="bar"
                                width="100%"
                                :options="barChartOptions"
                                :series="barChartData"
                            ></apexcharts>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
    name: "consultant-management-chart",
    props: {
        chartStatus: { type: Array, required: true },
        chartMapel: { type: Array, required: true },
    },
    components: {
        apexcharts: VueApexCharts,
    },
    data() {
        return {
            loading: false,
            data: [],
            mapel: [],
            donutChartOptions: null,
            donutChartData: [],
            barChartOptions: null,
            barChartData: [],
            show: false,
            colorPie: [
                "#6173e6",
                "#e661b7",
                "#e66173",
                "#e69461",
                "#2dc9e2",
                "#a6dfff",
                "#6173e6",
                "#e661b7",
                "#e66173",
                "#e69461",
                "#2dc9e2",
                "#a6dfff",
                "#6173e6",
                "#e661b7",
            ],
            rawData: [],
        };
    },

    computed: {
        totalConsultants() {
            return this.donutChartData.reduce((a, b) => a + b, 0);
        },
    },

    mounted() {
        this.getDonutChartData();
        this.getBarChartData();

        setTimeout(() => {
            this.show = true;
        }, 600);
    },

    methods: {
        getDonutChartData() {
            this.donutChartOptions = {
                chart: {
                    type: "donut",
                    margin: 0,
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    },
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: "55%",
                        },
                    },
                },
                labels: [],
                legend: {
                    show: false,
                },
                colors: this.colorPie,
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return (
                                new Intl.NumberFormat("id-ID").format(val) +
                                " Konsultasi"
                            );
                        },
                    },
                },
            };

            const labels = this.chartMapel.map((item) => item.mapel_name);
            const series = this.chartMapel.map((item) => item.total);

            this.donutChartOptions.labels = labels;
            this.donutChartData = series;
        },

        getBarChartData() {
            var rawData = [
                {
                    status: "Finished",
                    total: this.chartStatus.total_consul_finished,
                },
                {
                    status: "Request",
                    total: this.chartStatus.total_consul_waiting,
                },
                {
                    status: "Timeout",
                    total: this.chartStatus.total_consul_timeout,
                },
                {
                    status: "Canceled",
                    total: this.chartStatus.total_consul_canceled,
                },
            ];

            this.barChartOptions = {
                chart: {
                    type: "bar",
                    toolbar: {
                        show: false,
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "50%",
                        distributed: true,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return new Intl.NumberFormat("id-ID").format(val);
                        },
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return (
                                new Intl.NumberFormat("id-ID").format(val) +
                                " Konsultasi"
                            );
                        },
                    },
                },
                legend: {
                    show: false,
                },
                colors: ["#00cf3f", "#d7dfe9", "#f2af17", "#eb3123"],
            };

            const labels = rawData.map((item) => item.status);
            const series = rawData.map((item) => item.total);

            this.barChartOptions.xaxis.categories = labels;
            this.barChartData = [
                {
                    name: "Konsultasi",
                    data: series,
                },
            ];
        },

        formatNumber(value = 0) {
            return new Intl.NumberFormat("id-ID", {
                maximumFractionDigits: 0,
            }).format(value);
        },
    },
};
</script>

<style>
.donut-container {
    position: relative;
    margin-bottom: 10px;
}

.custom-label {
    margin-top: -50%;
    width: 100%;
    text-align: center;
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// ConsulActivityChart.vue?e46a2a8c